const checkout = {
  marginTop: '42px',
};

export default checkout;
